<template >
  <v-container style="margin-top: 70px; margin-bottom: 70px;">

    <v-row class="d-flex justify-center" no-gutters>
      <v-col cols='12' no-gutters>
        <div class="header1">
          <span class="text-center" style="font-weight: bold; font-size: 22px; padding-bottom: 10px;">ניהול eSIMS</span>
        </div>
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center">
      <v-col cols='auto' lg='6'>
        <div class="header2">

          <v-text-field v-model="search" append-icon="mdi-magnify" label="חיפוש" flat single-linehide-details
            class="search">
          </v-text-field>
          <div class="d-flex flex-wrap pa-3 ">
            <v-btn medium color="black" outlined dark class="mb-2 ms-2" style=" border-color: #dddfe1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="#9ea1a5" dark @click="downloadExcel()">
                    mdi-file-download
                  </v-icon>
                </template>
                <span>הורד לקובץ אקסל</span>
              </v-tooltip>
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols='auto' lg='6' v-if="$vuetify.breakpoint.mdAndUp">
      </v-col>
    </v-row>

    <v-row class="d-flex justify-center">

      <v-data-table id="table1" :headers="headers" :items="esimsList" :search="search" sort-by="index"
        :footer-props="{ 'items-per-page-options': [20, 50, 100, 500], 'items-per-page-text': 'שורות בעמוד:' }"
        style="background-color: #f3f6f9;">

        <template v-if="$vuetify.breakpoint.mdAndUp" v-for="header in headers"
          v-slot:[`header.${header.value}`]="{ header }">
          <span class="table-headers">{{ header.text }}</span>
        </template>

        <template v-if="$vuetify.breakpoint.mdAndUp" #item="{ item, index }">
          <tr class="table-rows">
            <td class="table-cells">{{ index + 1 }}</td>
            <td class="table-cells">{{ item.phone }}</td>
            <td class="table-cells">{{ item.status }}</td>
            <td class="table-cells" style="color: #abafb3 !important">{{ item.created_at }}</td>
            <td class="table-cells" style="color: #abafb3 !important">{{ item.modified_at }}</td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-row v-if="progressShow" class="my-5">
            <v-col class="d-flex justify-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
          <div class="ma-5">
            <span class="text-center" style="font-weight: bold; font-size: 25px; font-family: Times, serif;">אין
              עדיין נתונים </span>
          </div>
          <v-btn color="#0099cd" dark @click="getEsimsListDetails()" style="margin-bottom: 10px;">
            Reset
          </v-btn>
        </template>

      </v-data-table>
    </v-row>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

  </v-container>
</template>
  
<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import TableToExcel from "@linways/table-to-excel";
import utils from '@/util/utils'

export default {
  components: {
    SnackBar,
  },
  data: () => ({
    isResponsive: false,
    headers: [
      { text: '#', value: "index", sortable: false, width: "70px" },
      { text: 'מספר נייד', align: 'start', value: 'phone', width: "180px" },
      { text: 'סטטוס', value: 'status', width: "120px" },
      { text: 'נוצר בתאריך', value: 'created_at', width: "180px" },
      { text: 'עודכן בתאריך', value: 'modified_at', width: "180px" },
    ],
    esimsList: [],
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    search: "",
  }),

  methods: {

    async getEsimsListDetails() {
      try {
        this.esimsList = [];
        this.progressShow = true;
        let token = localStorage.getItem("token");

        let api = process.env.VUE_APP_BASE_URL + "/admin/esims_list";
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        this.progressShow = false;
        const jsonObject = await res.json();
        if (res.status === 400) {
          this.showSnackBar("שגיאה בקבלת נתונים", "red");
        } else if (res.status === 200) {
          this.esimsList = jsonObject;
          this.translateToHebrewAndDates();
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error get esims list: " + error, "red");
      }
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    
    translateToHebrewAndDates() {
      this.esimsList = this.esimsList.map((obj) => {
        return {
          ...obj,
          status: obj.status === "new" ? "חדש" : obj.status === "used" ? "משומש" : obj.status,
          created_at: utils.getCurrentDate(obj.created_at),
          modified_at: utils.getCurrentDate(obj.modified_at),
        }
      });
    },
    
    downloadExcel() {
      // Create a copy of the headers with English text
      const englishHeaders = [
        { text: '#', value: "index", sortable: false },
        { text: 'phone', align: 'start', value: 'phone', },
        { text: 'status', value: 'status' },
        { text: 'created_at', value: 'created_at' },
        { text: 'modified_at', value: 'modified_at' },
      ];
      
      // Clone the table
      const table = document.getElementById('table1');
      const clonedTable = table.cloneNode(true);
      
      // Replace the table headers with the English headers in the cloned table
      const tableHeaders = clonedTable.getElementsByTagName('th');
      for (let i = 0; i < englishHeaders.length; i++) {
        tableHeaders[i].textContent = englishHeaders[i].text;
      }
      
      // Remove the first header
      tableHeaders[0].parentNode.removeChild(tableHeaders[0]);
      
      // Remove the first column from the cloned table
      const tableRows = clonedTable.getElementsByTagName('tr');
      for (let i = 0; i < tableRows.length; i++) {
        const tableCells = tableRows[i].getElementsByTagName('td');
        if (tableCells.length > 0) {
          tableCells[0].parentNode.removeChild(tableCells[0]); // Remove the first cell
        }
      }
      
      // Download the Excel file from the cloned table
      TableToExcel.convert(clonedTable, {
        name: 'esimsList.xlsx',
        sheet: {
          name: 'Sheet 1',
        },
      });
    },
  },
  mounted() {
    this.getEsimsListDetails();
  },
}
</script>
<style scoped>
.header1 {
  background-color: #fff;
  height: 89px;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.header2 {
  min-height: 89px;
  display: flex;
}

.search {
  width: 332px !important;
  height: 49px;
  max-width: 100% !important;
  padding: 10px !important;
  padding-right: 10px !important;
  border: 1px solid #dddfe1 !important;
  box-sizing: border-box !important;
  font-size: 15px !important;
  font-family: "circular-std-book" !important;
}

.table-headers {
  font-family: 'Circular-std-book' !important;
  font-size: 18px;
  font-weight: 100 !important;
}

.table-rows {
  background-color: #FFFFFF !important;
  height: 89px !important;
  box-shadow: -1.8369701465288538e-16px 3px 10px rgba(119, 119, 119, 0.1) !important;
  border-radius: 3px !important;
}

.table-cells {
  font-family: 'Circular-std-book' !important;
  font-size: 16px !important;
  color: #6a707e;
}

/* remove underline from textfield  */
.v-text-field>.v-input__control>.v-input__slot:before {
  width: 0px !important
}

table {
  border-collapse: separate !important;
  border-spacing: 0px 10px !important;
}
</style>